/**
 * HTMX Setup
 * Configures HTMX and makes it globally available. Mirrors apps/fastapi/leapfile.
 */
import htmx from "htmx.org";

// Expose htmx globally so inline template scripts and dynamically injected
// content can call htmx.process(...) on nodes htmx didn't load itself.
window.htmx = htmx;

// Swap content on error responses so server-rendered error templates display.
// HTMX 2's default ignores 4xx/5xx bodies, which would hide the global
// AppException / handle_unexpected_exception error_content fragment delivered
// via HX-Retarget on a 4xx/5xx status.
htmx.config.responseHandling = [
  { code: "204", swap: false },
  { code: "[23]..", swap: true },
  { code: "[45]..", swap: true, error: true },
];

export { htmx };
